import React, { useContext } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import {
  MyNexarContext,
  MyNexarContextType,
} from "../components/my-nexar-context/my-nexar-context";
import Header from "../components/header/header";
import styles from "./app-wrapper.module.scss";
import { useDI } from "../core/di";
import { Toaster } from "./connect/components/toaster/toaster";

export function AppWrapper(props: any) {
  const navigate = useNavigate();
  const context = useContext<MyNexarContextType>(MyNexarContext);
  const { nexarApi } = useDI();

  const handleLogout = async () => {
    await nexarApi.logout();
    context?.clearLoggedInUser();
    navigate("/", { replace: true });
  };

  return (
    <div className={styles.AppWrapper}>
      <Header user={context?.user} onLogout={handleLogout} />
      <Toaster />
      <Outlet />
    </div>
  );
}

export default AppWrapper;
